export { default } from './ChangePasswordFormModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ChangePasswordFormModal/index.js